import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { Link } from "wouter";
import { Calculator, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { CALCULATOR_CARDS } from "@/data/calculator-cards";

export default function Calculators() {
  return (
    <>
      <Navbar />
      <main id="main-content" className="pt-20 min-h-screen">
        <section className="py-24 relative">
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" />
          <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
            <div className="mb-16">
              <div className="flex items-center gap-3 mb-6">
                <div className="h-px w-8 bg-primary" />
                <span className="text-primary font-medium tracking-wide uppercase text-sm">Founder Resources</span>
              </div>
              <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold mb-6" data-testid="text-calculators-title">Startup Calculators</h1>
              <p className="text-xl text-muted-foreground max-w-2xl">
                Essential financial calculators for founders. Each calculator includes worked examples, FAQs, and actionable guidance.
              </p>
            </div>

            <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" aria-label="Available startup calculators">
              {CALCULATOR_CARDS.map((calc) => (
                <li key={calc.slug}>
                  <Link href={`/calculators/${calc.slug}`} aria-label={`Open ${calc.title}`}>
                    <Card className="border-white/5 p-5 h-full hover:border-primary/30 hover:bg-white/[0.02] transition-all duration-200 cursor-pointer group" data-testid={`card-calc-${calc.slug}`}>
                      <div className="flex items-start gap-3 mb-3">
                        <Calculator size={18} className="text-primary shrink-0 mt-0.5" aria-hidden="true" />
                        <h2 className="font-display font-semibold leading-tight text-base">{calc.title}</h2>
                      </div>
                      <p className="text-sm text-muted-foreground leading-relaxed mb-4">{calc.desc}</p>
                      <div className="flex items-center gap-1.5 text-primary text-sm font-medium group-hover:gap-2.5 transition-all" aria-hidden="true">
                        <span>Open Calculator</span>
                        <ArrowRight size={14} />
                      </div>
                    </Card>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
